<div class="row mt-2">
  <div class="col-md-6 mb-3">
    <label class="input-label d-block">{{ 'dashboard.ArchivedBinders' | translate }}</label>
    <p-dropdown
      [options]="optionsArchived | sort: 'label' : 'ASC'"
      styleClass="w-100"
      appendTo="body"
      [placeholder]="'dashboard.chooseOption' | translate"
      [(ngModel)]="ClasseurArchived"
      [filter]="true"
      [emptyFilterMessage]="'dashboard.noResult' | translate"
      [showClear]="true"
      (onChange)="onServiceSelect(selectedServiceLV)"></p-dropdown>
  </div>
  <div class="col-md-6 mb-3">
    <label class="input-label d-block">{{ 'dashboard.ArchivedPlasticLiners' | translate }}</label>
    <p-dropdown
      [options]="optionsArchived | sort: 'label' : 'ASC'"
      styleClass="w-100"
      appendTo="body"
      [placeholder]="'dashboard.chooseOption' | translate"
      [(ngModel)]="ChemiseArchived"
      [filter]="true"
      [emptyFilterMessage]="'dashboard.noResult' | translate"
      [showClear]="true"
      (onChange)="onServiceSelect(selectedServiceLV)"></p-dropdown>
  </div>
</div>
@if (serviceParent?.length > 0) {
  <div class="form-group">
    <div class="row">
      <div class="col-12">
        <h4 class="custom-h4-title">{{ 'service' | translate }} (*)</h4>
      </div>
      <div class="col-12 p-fluid">
        @if (serviceParent?.length > 1) {
          <p-treeSelect
            #treeSelect
            [propagateSelectionUp]="false"
            [propagateSelectionDown]="true"
            selectionMode="checkbox"
            [options]="serviceParent"
            [placeholder]="'pleaseSelectAService' | translate"
            appendTo="body"
            (onNodeSelect)="select()"
            (onNodeUnselect)="unselect($event)"
            [emptyMessage]="'noResultFound' | translate"
            [filter]="true"
            [filterPlaceholder]="'global.filterPlaceholder' | translate"
            [filterBy]="'label'"
            [filterMode]="'strict'"
            [metaKeySelection]="false">
          </p-treeSelect>
        }
        @if (serviceParent?.length === 1) {
          <p-dropdown
            styleClass="w-100"
            [options]="serviceParent"
            [(ngModel)]="selectedServiceLV"
            placeholder=""
            styleClass="w-100 dropdown-inforius"
            id="oneServ"
            appendTo="body"
            (onChange)="onServiceSelect($event.value)">
          </p-dropdown>
        }
      </div>
    </div>
  </div>
}

@if (serviceParent?.length === 0) {
  <p class="tips">{{ 'dashboard.noDataToShowNoService' | translate }}</p>
}

@if (selectedServiceLV) {
  <div>
    <div class="row">
      <div class="col-12" style="height: 80vh">
        @if (classements.length > 0) {
          <p-tree
            [value]="classements"
            selectionMode="single"
            [(selection)]="selectedClassement"
            (onNodeSelect)="onClassementSelect($event.node)"
            [emptyMessage]="'noResultFound' | translate"
            styleClass="w-100 tree-scrollable"
            [filter]="true">
            <ng-template let-node pTemplate="classeur">
              <span class="tree__classeur overflow-ellipsis" pTooltip="{{ node.label }}" tooltipPosition="bottom">
                @if (node.archived) {
                  <i class="bi bi-archive"></i>
                }
                {{ node.label }}
              </span>
            </ng-template>
            <ng-template let-node pTemplate="chemise">
              <span class="tree__chemise overflow-ellipsis" pTooltip="{{ node.label }}" tooltipPosition="bottom">
                @if (node.archived) {
                  <i class="bi bi-archive"></i>
                }
                {{ node.label }}
              </span>
            </ng-template>
          </p-tree>
        }
        @if (classements && classements.length === 0) {
          <div class="alert alert-primary">{{ 'dashboard.noDataToShow' | translate }}</div>
        }
      </div>
    </div>
  </div>
}
